module.exports = __webpack_public_path__ + "static/media/order_icon18.6e6a5abb.png";